<template>
  <v-card
    max-width="330px"
    flat
    v-if="file.id"
    :class="{ pointer: pickerMode }"
    v-on="pickerMode ? { click: () => toggleFileHandler(file.id) } : {}"
  >
    <v-card-text class="pa-0">
      <component
        :is="`MediaPreview${file.type}`"
        :file="file"
        :is-chosen="isChosen"
        :picker-mode="pickerMode"
        :hide-delete="hideDelete"
        @choose-file="previewFileHandler"
        @remove-file="removeFile"
      >
        <template v-if="pickerMode" #body>
          <v-card-subtitle class="pb-0">
            {{ file.type }}
          </v-card-subtitle>
          <v-card-text class="text--primary">
            {{ file.fileName }}
          </v-card-text>
        </template>
      </component>
    </v-card-text>
    <PreviewDialog
      v-if="isImagePreviewOpen"
      ref="previewDialog"
      :file="file"
      :caption="caption"
      @close="isImagePreviewOpen = false"
    />
  </v-card>
</template>

<script>
import fileQuery from '@/services/gql/types/Files/queries/file.gql'
import MediaPreviewAUDIO from '@/components/media-file-preview/types/media-preview-AUDIO'
import MediaPreviewIMAGE from '@/components/media-file-preview/types/media-preview-IMAGE'
import MediaPreviewVIDEO from '@/components/media-file-preview/types/media-preview-VIDEO'
import PreviewDialog from '@/components/media-file-preview/dialog/PreviewDialog'

export default {
  name: 'MediaFilePreview',
  components: { PreviewDialog, MediaPreviewVIDEO, MediaPreviewIMAGE, MediaPreviewAUDIO },
  props: {
    value: {
      type: [Object, Number],
      default: null
    },
    isChosen: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '100px'
    },
    width: {
      type: String,
      default: '100px'
    },
    description: {
      type: Boolean,
      default: false
    },
    pickerMode: {
      type: Boolean,
      default: false
    },
    hideDelete: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      file: typeof this.value === 'object' && this.value !== null ? this.value : {},
      isImagePreviewOpen: false
    }
  },
  watch: {
    value: {
      deep: true,
      handler (newVal) {
        if (typeof newVal === 'object' && newVal !== null) {
          this.file = newVal || {}
        }
      }
    }
  },
  methods: {
    previewFileHandler () {
      if (!this.pickerMode) {
        this.isImagePreviewOpen = true
      }
    },
    removeFile (fileId) {
      this.file = {}
      this.toggleFileHandler(fileId)
    },
    toggleFileHandler (fileId) {
      this.$emit('change', fileId)
    }
  },
  apollo: {
    file: {
      query: fileQuery,
      fetchPolicy: 'network-only',
      skip () {
        return this.pickerMode || typeof this.value === 'object'
      },
      variables () {
        return { where: { id: this.value } }
      },
      context () {
        return {
          headers: {
            Language: 'ru,en,ko,ja,zh'
          }
        }
      }
    }
  }
}
</script>
